import { render, staticRenderFns } from "./EmirexInfoModal.vue?vue&type=template&id=70213ee4&scoped=true"
import script from "./EmirexInfoModal.vue?vue&type=script&lang=ts"
export * from "./EmirexInfoModal.vue?vue&type=script&lang=ts"
import style0 from "./EmirexInfoModal.vue?vue&type=style&index=0&id=70213ee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70213ee4",
  null
  
)

export default component.exports